module.exports = __webpack_public_path__ + "media/src/images/icons/open_new_window-92ebae2c35613318813afde35e6c7cb8.svg";